export const setJackpots = (games, jackpots) => {
    let items = games
    items = items.map((item) => {
        jackpots &&
            jackpots.length &&
            jackpots.forEach((jackpot) => {
                if (item.game_id === jackpot.game_id) {
                    item.jackpot_amount = jackpot.jackpot_amount
                    item.jackpot_amount_formatted =
                        jackpot.jackpot_amount_formatted
                }
            })
        return item
    })

    return items
}
